export const TOTAL_STEP_COUNT: number = 5;

/**
 * Устанавливает соответствие между наименованием экрана и его порядковым номером.
 */
export const StepOrder = {
    STEP_VIEW_PRODUCT_DATA: 1,
    STEP_GET_PERSONAL_DATA: 2,
    STEP_PERSONAL_DATA: 2,
    STEP_JOB_DATA: 3,
    STEP_CHOOSE_PRODUCT_DATA: 4,
};

export const STEP_PROGRESS_PERCENT = 25;
